import { render, staticRenderFns } from "./EditDrawingView.vue?vue&type=template&id=63f536a1"
import script from "./EditDrawingView.vue?vue&type=script&lang=js"
export * from "./EditDrawingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports